


































import {
  Component,
  Vue,
  Config,
  TModelBase,
  Model,
  Watch,
  Prop
} from "@/common";

import { TwTable } from "@/components";
@Component({})
export default class OrderItems extends TModelBase {
  switchShowTModel(val) {
    if (val === true) {
      this.$http.get('Biz/Order/GetItemList',{params:{
        H_GUID:this.propkey
      }}).then(res=>{
        this.data.splice(0);
        this.data.push(...res.data.items)
      })
    }
  }

  @Prop({})
  private contrs!: Array<any>;

  @Prop({})
  private propkey!: String;

  get itemsTable(): TwTable {
    return this.$refs["itemsTable"] as TwTable;
  }

  dataLoading = false;

  saveMask = false;

  columns = [];

  data = [];

  deleteData = [];

  add() {
    this.itemsTable.addNewRow({
      GUID: null,
      H_GUID: "",
      CHILD_NO: "",
      GOODS_NAME: "",
      QTY: 0,
      NOTE: "",
      CREATE_USER: null,
      CREATE_DATE: null
    });
    this.$nextTick(() => {
      this.itemsTable.startEditing(-1);
    });
  }

  addRender(h, params) {
    return (
      <span
        style="cursor:pointer"
        onClick={() => {
          this.add(); // 合并编辑:表体添加事件
        }}
      >
        子运单号
        <i
          class="el-icon-circle-plus-outline"
          style="margin-left:10px;color:green"
        />
      </span>
    );
  }

  OperationRender(props) {
    return (
      <div style="display:inline;">
        <el-button
          style="padding:7px;"
          type="danger"
          onClick={() => {
            this.$confirm(`确定删除当前数据么?`, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.itemsTable.deleteRow(props.$index);
                if (props.row.GUID) {
                  let row = props.row;
                  delete row.$editable;
                  this.deleteData.push(row);
                }
              })
              .catch(() => {});
          }}
        >
          删除
        </el-button>
      </div>
    );
  }

	cellChange(newVal,oldVal,row){
  		console.log(newVal);
		console.log(oldVal);
		console.log(row);
	}

  Save() {
    this.saveMask = true;
    this.$http
      .post("Biz/Order/ItemSave", {
        H_GUID: this.propkey,
        list: this.itemsTable.getData(),
        dels: this.deleteData
      })
      .then(res => {
        if (res.data.status === 0) {
          this.saveMask = false;
          this.$message.success("保存成功");
          this.showTModel = false;
          this.$emit("on-ok");
        } else {
          this.saveMask = false;
          this.$message.warning(res.data.msg || "保存失败");
        }
      })
      .catch(err => {
        this.saveMask = false;
        this.$message.warning(err);
      });
  }

  mounted() {
    this.buildColumn("OrderItems", this.columns);
  }
}
